(() => {
  const fallback = document.querySelector('[data-wh-contact-fallback]');
  const roots = [...document.querySelectorAll('[data-form-root]')];
  if (!fallback || !roots.length) return;
  let started = false;
  fallback.addEventListener('input', () => { started = true; });
  const sync = () => {
    if (started) return;
    fallback.hidden = roots.some(root => root.getBoundingClientRect().height > 80 && root.children.length > 0);
  };
  const resize = new ResizeObserver(sync);
  roots.forEach(root => resize.observe(root));
  sync();
})();
